var stripeChargeMixin = {
  methods: {
    getChargebleAmount (quantity = null) {
      let amount = 99.00
      let numDistributors
      if (quantity === null) {
        numDistributors = this.getDistributorsQuantity()
      } else {
        numDistributors = quantity
      }

      if (numDistributors > 5) {
        amount += (numDistributors - 5) * 9
      }

      return amount
    },
    getDistributorsQuantity () {
      let quantity = 0
      if (this.supplier_distributors) {
        quantity = this.supplier_distributors.length
      }
      return quantity
    }
  }
}

export default stripeChargeMixin
